import { useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import ReactGA from "react-ga4";
import { Button, Flex, Image, useColorModeValue } from "@chakra-ui/react";
import PageLayout, { PageHeader } from "../components/layout/PageLayout";
import { TONE } from "../styles/theme";

const SORRY_GIF =
  "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExeWgzd2c3MnIxa29jd2Mzb3FuejVqNmN5MHdkY2QxOXJkMjFzejF1dyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/3ohA2ZD9EkeK2AyfdK/giphy.gif";

// Centred rather than left-aligned like the other interior pages: there's no prose or form
// here to read down, just a dead end and the way out.
export default function NotFoundPage({
  title = "Page not found",
  subtitle = "The link may be outdated. Head back to Kuthé to find the app, the map, or support.",
  gaTitle = "404-not-found",
}) {
  const border = useColorModeValue(TONE.light.border, TONE.dark.border);

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: gaTitle,
      location: window.location.href,
    });
  }, [gaTitle]);

  return (
    <PageLayout narrow pt={{ base: 10, md: 16 }}>
      <PageHeader
        align="center"
        backLabel={null}
        title={title}
        subtitle={subtitle}
      />
      <Image
        src={SORRY_GIF}
        alt=""
        borderRadius="16px"
        border="1px solid"
        borderColor={border}
        maxW="320px"
        w="100%"
        mx="auto"
        mb={8}
      />
      <Flex gap={3} wrap="wrap" justify="center">
        <Button as={RouterLink} to="/">Back to home</Button>
        <Button as={RouterLink} to="/explore" variant="outline">Explore the map</Button>
      </Flex>
    </PageLayout>
  );
}
